import { render, staticRenderFns } from "./order-limbo-container.vue?vue&type=template&id=2fbeefa7&"
import script from "./order-limbo-container.vue?vue&type=script&lang=js&"
export * from "./order-limbo-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports